import config from 'config/default';
import { Roles } from 'enums';
import { User } from 'hooks/use-extension-auth';
import _ from 'lodash';

export const allowTextGen = () => {
  const storedBasics = localStorage.getItem('user-basics');
  const parsedBasics = !_.isNil(storedBasics) ? (JSON.parse(storedBasics) as User) : undefined;
  const email = parsedBasics?.email;

  let isBlacklisted = false;
  let isWhitelisted = false;

  if (!_.isNil(email)) {
    const blacklist: string[] = config.textGenBlacklist;

    blacklist.forEach((item) => {
      if (email.toLocaleLowerCase().includes(item.toLocaleLowerCase()) && item !== '') {
        isBlacklisted = true;
      }
    });

    const whitelist: string[] = config.textGenWhitelist;

    whitelist.forEach((item) => {
      if (email.toLocaleLowerCase() === item.toLocaleLowerCase()) {
        isWhitelisted = true;
      }
    });
  }

  return !isBlacklisted || isWhitelisted;
};

export const allowContactManagement = (role: Roles) => {
  if (role === Roles.ADMIN || role === Roles.OWNER) {
    return true;
  }

  const storedBasics = localStorage.getItem('user-basics');
  const parsedBasics = !_.isNil(storedBasics) ? (JSON.parse(storedBasics) as User) : undefined;
  const userEmail = parsedBasics?.email;

  const whitelist: string[] = config.contactManagementWhitelist;

  if (!_.isNil(userEmail)) {
    // Check if the full email is in the whitelist
    if (_.includes(whitelist, userEmail)) {
      return true;
    }

    // Extract the domain from the email (including the '@')
    const emailDomain = '@' + userEmail.split('@')[1];

    // Check if the domain is in the whitelist
    if (_.includes(whitelist, emailDomain)) {
      return true;
    }
  }

  return false;
};

export const allowPostingCreation = (role: Roles) => {
  if (role === Roles.ADMIN || role === Roles.OWNER) {
    return true;
  }

  const storedBasics = localStorage.getItem('user-basics');
  const parsedBasics = !_.isNil(storedBasics) ? (JSON.parse(storedBasics) as User) : undefined;
  const userEmail = parsedBasics?.email;

  // For now only allow simon.tschuertz@secret-ai-agent.de
  const whitelist: string[] = ['simon.tschuertz@secret-ai-agent.de'];

  if (!_.isNil(userEmail) && whitelist.includes(userEmail)) {
    return true;
  }

  return false;
};

export const allowLeadListResearch = (role: Roles) => {
  if (role === Roles.ADMIN || role === Roles.OWNER) {
    return true;
  }

  const storedBasics = localStorage.getItem('user-basics');
  const parsedBasics = !_.isNil(storedBasics) ? (JSON.parse(storedBasics) as User) : undefined;
  const userEmail = parsedBasics?.email;

  // Allow specific users and all from @boerding.com and @vantisgo.de
  const whitelist: string[] = ['simon.tschuertz@secret-ai-agent.de', 'josip.coric@adyx.at'];
  const allowedDomains = ['@boerding.com', '@vantisgo.de'];

  if (!_.isNil(userEmail)) {
    if (whitelist.includes(userEmail)) {
      return true;
    }
    if (allowedDomains.some(domain => userEmail.endsWith(domain))) {
      return true;
    }
  }

  return false;
};
